(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentType', IncidentType);

    IncidentType.$inject = ['$resource'];

    function IncidentType ($resource) {
        var resourceUrl =  'api/incident-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/incident-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
